import * as PropTypes              from 'prop-types';
import {
    compose,
    withState,
    getContext,
    lifecycle,
    withProps
}                                  from 'recompose';
import { MessageComponentProps }   from './MessageTypes';
import MessageComponent            from './MessageComponent';
import { MessageDeliveryStatuses } from '../../types';

const FAILURE_TIMEOUT = 30000;

const MessageComponentContainer = compose(
    getContext({
        translate: PropTypes.func.isRequired
    }),
    withState('messageFailed', 'setMessageFailed', false),
    withProps(({ message, sendMessage, conversationId }: MessageComponentProps) => ({
        retrySendingMessage() {
            sendMessage(conversationId, message.content);
        }
    })),
    lifecycle<MessageComponentProps, {}>({
        componentDidMount() {
            // If a message was loaded from a past session, ignore this check entirely
            if (!this.props.message.currentSession) {
                return false;
            }

            // If a message hasn't received an 'ok' status in 30 seconds, consider it to be failed
            if (this.props.message.currentSession && this.props.message.delivery_status !== MessageDeliveryStatuses.SUCCESS) {
                (this as any).failInterval = setTimeout(() => {
                    this.setState({
                        messageFailed: true
                    });
                    this.props.scrollToBottom();
                }, FAILURE_TIMEOUT);
            }
        },
        componentDidUpdate(prevProps) {
            if (this.props.error && this.props.error !== prevProps.error && (this.props.error.messageId === this.props.message.id || this.props.error.templateId === this.props.message.templateId)) {
                clearTimeout((this as any).failInterval);
                this.props.setMessageFailed(true);
            }

            // clear the failure timeout when the message is delivered successfully
            if (this.props.message.delivery_status !== prevProps.message.delivery_status && this.props.message.delivery_status === MessageDeliveryStatuses.SUCCESS) {
                clearTimeout((this as any).failInterval);
            }
        },
        componentWillUnmount() {
            clearTimeout((this as any).failInterval);
        }
    })
);

export default MessageComponentContainer(MessageComponent) as React.ComponentClass<MessageComponentProps>;



// WEBPACK FOOTER //
// ./src/sections/Message/index.ts